import React from 'react';

export function SeparatorBlock({ data }) {
    const title = data?.title;

    if (!title) {
        return (
            <div className="separator-block">
                <div className="separator-block__line" />
            </div>
        );
    }

    return (
        <div className="separator-block">
            <div className="separator-block__line" />
            <span className="separator-block__title">{title}</span>
            <div className="separator-block__line" />
        </div>
    );
}
